// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../common/Components/IconV5.bs.js");
let DateFns = require("date-fns");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizard__WarningHeader = require("./PropertyWizard__WarningHeader.bs.js");
let PropertyWizardRelayRebroadcastWarning_draft_graphql = require("../../../__generated__/PropertyWizardRelayRebroadcastWarning_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayRebroadcastWarning_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__RebroadcastWarning(props) {
  let policy = props.policy;
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayRebroadcastWarning_draft_graphql.node, convertFragment, props.draft);
  let match$1 = React.useState(() => false);
  let hasHadLocallyValidPrice = match$1[0];
  let exit = 0;
  let exit$1 = 0;
  if (typeof mode !== "object" || mode.TAG !== "Rebroadcast") {
    exit$1 = 3;
  } else {
    switch (policy.__typename) {
      case "PropertyBroadcastAllowed" :
        exit$1 = 3;
        break;
      case "PropertyBroadcastNotAllowed" :
        return "This property cannot be rebroadcast";
      case "__unselected" :
        return null;
    }
  }
  if (exit$1 === 3) {
    switch (policy.__typename) {
      case "PropertyBroadcastAllowed" :
        let match$2 = policy.priceCondition;
        if (match$2 === undefined) {
          return null;
        }
        if (match$2.currentPriceQualifies) {
          return null;
        }
        let requiredUntil = match$2.requiredUntil;
        let match$3 = match$2.maxPrice;
        let maxPrice = match$3.value;
        let match$4 = draft.draftProperty;
        let price = match$4.minPrice;
        let hasLocallyValidPrice;
        let exit$2 = 0;
        let price$1 = match$4.price;
        if (price$1 !== undefined && !match$4.priceRange) {
          hasLocallyValidPrice = price$1 <= maxPrice;
        } else {
          exit$2 = 4;
        }
        if (exit$2 === 4) {
          hasLocallyValidPrice = price !== undefined && match$4.priceRange ? price <= maxPrice : false;
        }
        if (!hasLocallyValidPrice && !hasHadLocallyValidPrice) {
          let priceBullet = `If the price is lowered by 5% (to ` + match$3.formatted + `) or more, you can rebroadcast immediately.
                      This is to give advance notice, so only rebroadcast if the price drop is not yet on the MLS.`;
          let nextBroadcastDateBullet = Stdlib_Option.map(requiredUntil, date => {
            let date$1 = DateFns.format(CalendarDate.toLocalDate(date), "MMMM do");
            return `This property will be eligible for rebroadcasting on ` + date$1;
          });
          let mlsTimingInfoBullet = requiredUntil !== undefined ? undefined : `Since this property was not originally entered at least 3 days before going Active on the MLS, it can only be rebroadcast
                 if the price is lowered by 5% or more. Use the blue messenger at the bottom right if you have any questions.`;
          return JsxRuntime.jsx(PropertyWizard__WarningHeader.make, {
            icon: JsxRuntime.jsx(IconV5.make, {
              icon: "attention-alt",
              size: 30,
              className: "text-black"
            }),
            headingText: "This property is not currently eligible to be rebroadcast",
            variant: "Error",
            children: JsxRuntime.jsx("ul", {
              children: Stdlib_Array.keepSome([
                nextBroadcastDateBullet,
                priceBullet,
                mlsTimingInfoBullet
              ]).map((item, idx) => JsxRuntime.jsxs("li", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(IconV5.make, {
                      icon: "bullet",
                      size: 24,
                      className: "text-tan-blue-500"
                    }),
                    className: "mr-1 mt-0.5"
                  }),
                  JsxRuntime.jsx("span", {
                    children: item
                  })
                ],
                className: idx === 0 ? "flex mt-0" : "flex mt-9"
              }, idx.toString())),
              className: "list-none m-0 p-0 text-lg leading-[1.5] font-medium"
            })
          });
        }
        if (hasLocallyValidPrice && !hasHadLocallyValidPrice) {
          match$1[1](param => true);
        }
        return null;
        break;
      case "PropertyBroadcastNotAllowed" :
      case "__unselected" :
        exit = 2;
        break;
    }
  }
  if (exit === 2 && typeof mode === "object" && mode.TAG === "Edit") {
    return null;
  }
  switch (policy.__typename) {
    case "PropertyBroadcastNotAllowed" :
      return "This property cannot be broadcast";
    case "PropertyBroadcastAllowed" :
    case "__unselected" :
      return null;
  }
}

let make = PropertyWizardRelay__RebroadcastWarning;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* react Not a pure module */
